const SectionHeader = ({ eyebrow, title, description, align = "left" }) => (
  <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
    {align === "center" && <div className="mx-auto mb-4 h-1 w-12 bg-brand-red" aria-hidden="true" />}
    {align !== "center" && <div className="mb-4 h-1 w-12 bg-brand-red" aria-hidden="true" />}
    <p className="eyebrow">{eyebrow}</p>
    <h2 className="mt-3 text-3xl font-semibold sm:text-4xl">{title}</h2>
    {description && (
      <p className="mt-4 text-base leading-relaxed text-brand-grey md:text-lg">{description}</p>
    )}
  </div>
);

export default SectionHeader;
